function DailyReport() {
  return <div>Banners</div>;
}

export default DailyReport;
